import { render, staticRenderFns } from "./RideCard.vue?vue&type=template&id=650add32&scoped=true&"
import script from "./RideCard.vue?vue&type=script&lang=js&"
export * from "./RideCard.vue?vue&type=script&lang=js&"
import style0 from "./RideCard.vue?vue&type=style&index=0&id=650add32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650add32",
  null
  
)

export default component.exports